<template>
  <!-- 动态控制显示/隐藏的确认弹窗 -->
  <div 
    id="confirm-modal"
    style="z-index: 9999;"
    class="fixed inset-0 z-102 flex items-center justify-center transition-opacity duration-300"
    :class="{
      'opacity-0 pointer-events-none': !isShow,  // 隐藏状态：透明+不可点击
      'opacity-100': isShow                     // 显示状态：不透明
    }"
  >
    <!-- 背景遮罩：与ToastModal保持一致的样式 -->
    <div 
      class="absolute inset-0 backdrop-blur-sm transition-opacity duration-300"
      :class="isShow ? 'bg-dark/90' : 'bg-dark/0'"
      id="confirm-backdrop"
    ></div>
    
    <!-- 弹窗内容：与ToastModal保持一致的样式 -->
    <div
      class="relative bg-dark-800 rounded-2xl w-full max-w-md mx-4 overflow-hidden gradient-border transform transition-transform duration-300"
      :class="{
        'scale-95 opacity-0': !isShow,  // 隐藏状态：缩小+透明
        'scale-100 opacity-100': isShow // 显示状态：正常大小+不透明
      }"
      id="confirm-content"
    >
      <div class="p-6 md:p-8 text-center">
        <div v-html="innerHTML" id="confirm-icon" class="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"></div>
        <h3 class="text-xl font-bold mb-2" id="confirm-title">{{title}}</h3>
        <p class="text-dark-600 mb-6" id="confirm-message">{{message}}</p>
        <!-- 双按钮布局 -->
        <div class="flex gap-4">
          <button 
            id="confirm-cancel"
            @click="handleCancel"
            class="flex-1 py-3 px-4 bg-dark-700 rounded-lg font-medium hover:bg-dark-600 transition-all duration-300"
          >
            取消
          </button>
          <button 
            id="confirm-ok"
            @click="handleConfirm"
            class="flex-1 py-3 px-4 bg-gradient-to-r from-primary to-accent rounded-lg font-medium hover:opacity-90 transition-all duration-300"
          >
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
export default {
  data(){
    return {
      isShow: false,
      title: '',
      message: '',
      innerHTML: '',
      onConfirm: null,  // 确认回调函数
      onCancel: null    // 取消回调函数
    }
  },
  mounted() {
    this.$bus.$on('showconfirm', (options) => {
      const { title, message, type = 'info', onConfirm, onCancel } = options;
      // 填充弹框内容
      this.title = title;
      this.message = message;
      this.onConfirm = onConfirm;
      this.onCancel = onCancel;
      
      // 图标样式设置（与ToastModal保持一致）
      const iconMap = {
        success: { class: 'fa-check text-green-500', bg: 'bg-green-500/20' },
        error: { class: 'fa-exclamation-circle text-red-500', bg: 'bg-red-500/20' },
        info: { class: 'fa-info-circle text-primary', bg: 'bg-primary/20' },
        warning: { class: 'fa-exclamation-triangle text-yellow-500', bg: 'bg-yellow-500/20' }
      };
      const icon = iconMap[type] || iconMap.info;
      this.innerHTML = `<i class="fa ${icon.class} text-2xl"></i>`;
      
      // 给图标容器添加背景色
      this.$nextTick(() => {
        const iconEl = document.querySelector('.w-16');
        if (iconEl) iconEl.className += ' ' + icon.bg;
      });
      
      this.isShow = true;
    });
  },
  methods: {
    handleConfirm() {
      this.isShow = false;
      if (typeof this.onConfirm === 'function') {
        this.onConfirm();
      }
      this.reset();
    },
    handleCancel() {
      this.isShow = false;
      if (typeof this.onCancel === 'function') {
        this.onCancel();
      }
      this.reset();
    },
    reset() {
      // 重置状态，避免内存泄漏
      this.onConfirm = null;
      this.onCancel = null;
    }
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    Vue.prototype.$bus.$off('showconfirm');
  }
}
</script>